import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Eyebrow, Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative border-t border-[var(--line)] bg-white py-24 lg:py-32">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Questions</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-black italic leading-[1] tracking-tight sm:text-5xl">Straight answers.</h2>
        <p className="mt-5 text-base leading-relaxed text-[var(--ink)]/70">Don't see yours? Call us. A real person picks up.</p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`f${i}`} className="border-[var(--line)]">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-bold italic hover:no-underline sm:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[var(--ink)]/75">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
